import { PlaybookStep } from "../model/Playbook";

export class GeneratedPlaybook {
  id: string;
  title: string;
  description: string;
  steps: PlaybookStep[];

  constructor(data: any) {
    this.id = data.id;
    this.title = data.title;
    this.description = data.description;
    this.steps = data.steps.map((step: any) => new PlaybookStep(step));
  }
}
